import {isNotNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetActiveSaleVehicleQuery, useGetRentalVehicleQuery} from '@dms/api/vehicle';
import {useGetServiceVehicleQuery} from '@dms/api/workshop';

export function useVehicleVariant(baseVehicleId: string) {
  const {
    data: saleVehicle,
    isLoading: isSaleVehicleLoading,
    isError: isSaleVehicleError,
  } = useGetActiveSaleVehicleQuery(
    {
      vehicleId: baseVehicleId,
    },
    {
      skip: isNilOrEmpty(baseVehicleId),
    }
  );
  const {
    data: rentalVehicle,
    isLoading: isRentalVehicleLoading,
    isError: isRentalVehicleError,
  } = useGetRentalVehicleQuery(
    {
      vehicleId: baseVehicleId,
    },
    {
      skip: isNilOrEmpty(baseVehicleId),
    }
  );
  const {
    data: serviceVehicle,
    isLoading: isServiceVehicleLoading,
    isError: isServiceVehicleError,
  } = useGetServiceVehicleQuery(
    {
      vehicleId: baseVehicleId,
    },
    {
      skip: isNilOrEmpty(baseVehicleId),
    }
  );

  return [
    {
      hasSaleVehicle: isNotNil(saleVehicle),
      hasRentalVehicle: isNotNil(rentalVehicle),
      hasServiceVehicle: isNotNil(serviceVehicle),
    },
    {
      isLoading: isSaleVehicleLoading || isRentalVehicleLoading || isServiceVehicleLoading,
      isError: isSaleVehicleError || isRentalVehicleError || isServiceVehicleError,
    },
  ];
}
